import React from "react";
import { Modal, Form, Input, Row, Col } from "antd";

const DeviceForm = ({ visible, onCancel, onConfirm, form, initialValues }) => {
  return (
    <Modal
      title="Edit Device"
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Submit"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        className="device-form"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="code"
              label="Code"
              rules={[{ required: true, message: "Please enter the code!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: "Please enter the name!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="units"
              label="Units"
              rules={[{ required: true, message: "Please enter the units!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="device_group"
              label="Device Group"
              rules={[
                { required: true, message: "Please enter the device group!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="device_type"
              label="Device Type"
              rules={[{ message: "Please enter the device type!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default DeviceForm;
